import type { SVGProps } from 'react';
const SvgRestoreFromTrash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#restore_from_trash_svg__a)">
      <path
        fill="currentColor"
        d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14V4ZM6 7v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6Zm8 7v4h-4v-4H8l4-4 4 4h-2Z"
      />
    </g>
    <defs>
      <clipPath id="restore_from_trash_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRestoreFromTrash;
